/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductBenefitModelSearchResultModel } from '../../models/product-benefit-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface ProductBenefitSearchProductBenefitPost$Params {
      body?: SearchRequestModel
}

export function productBenefitSearchProductBenefitPost(http: HttpClient, rootUrl: string, params?: ProductBenefitSearchProductBenefitPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ProductBenefitModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, productBenefitSearchProductBenefitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ProductBenefitModelSearchResultModel>;
    })
  );
}

productBenefitSearchProductBenefitPost.PATH = '/ProductBenefit/SearchProductBenefit';
